import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Fab, Badge, withStyles } from "@material-ui/core";
import { useIntl } from "react-intl";
import { NavigationArrowDownward } from "material-ui/svg-icons";

import { Container, MessageListInfiniteScroll } from "./styles";
import InputData from "./InputData";
import MessageBox from "./MessageBox";
import ActionHSM from "./ActionHSM";
import { InfiniteScroll, Loading } from "../../../_common";

const QUANTIDADE_BASE = 10;
function Chat({ chat, messages, onSendMessage, onSendNewFile, handleNewHsmMessage, classes }) {
  const intl = useIntl();
  const lastMessageRef = useRef(null);
  const [mensagensExibicao, setMensagensExibicao] = useState(
    messages.slice(Math.max(messages.length - QUANTIDADE_BASE, 0))
  );
  const [carregando, setCarregando] = useState(false);
  const [showBtnTopDown, setShowBtnTopDown] = useState(false);
  const [novasMensagens, setNovasMensagens] = useState(null);
  const [totalInicial, setTotalInicial] = useState(messages.length);

  useEffect(
    () => {
      const diferenca = messages.length - totalInicial;
      setNovasMensagens(diferenca);
      if (diferenca > 0) {
        const deveReposicionar = !showBtnTopDown;
        setCarregando(true);
        const total = mensagensExibicao.length + diferenca;
        setMensagensExibicao(messages.slice(Math.max(messages.length - total, 0)));
        setCarregando(false);
        if (deveReposicionar) reposicionarNovasMensagens();
      }
    },
    [messages]
  );

  useEffect(() => {
    document.getElementById("divEstiloCondicionalWrapperChatWpp").addEventListener("scroll", event => {
      if (event.target.scrollHeight - event.target.clientHeight <= event.target.scrollTop + 1)
        reposicionarNovasMensagens();
      else setShowBtnTopDown(true);
    });
  }, []);

  useEffect(
    () => {
      // Resposnsável por "marcar" as novas mensagens como lidas para o InfiniteScroll
      if (!showBtnTopDown) setTotalInicial(messages.length);
    },
    [showBtnTopDown]
  );

  useEffect(() => {
    reposicionar();
  }, []);

  const paginar = pagina => {
    setCarregando(true);
    const total = QUANTIDADE_BASE * pagina;
    setMensagensExibicao(messages.slice(Math.max(messages.length - total, 0)));
    setCarregando(false);
  };

  const reposicionar = () => {
    if (lastMessageRef) lastMessageRef.current.scrollIntoView();
  };

  const reposicionarNovasMensagens = () => {
    setNovasMensagens(null);
    setShowBtnTopDown(false);
    reposicionar();
  };

  return (
    <Container>
      <MessageListInfiniteScroll>
        <div id="divEstiloCondicionalWrapperChatWpp" className={classes.containerChatWpp}>
          <InfiniteScroll
            initialLoad={false}
            loadMore={paginar}
            hasMore={mensagensExibicao.length < messages.length}
            loader={<Loading className={classes.loadingChat} key={0} isLoading={carregando} />}
            useWindow={false}
            queryselector="#divEstiloCondicionalWrapperChatWpp"
            isReverse
          >
            {mensagensExibicao.map(message => <MessageBox key={message.id} message={message} />)}
          </InfiniteScroll>
          <span ref={lastMessageRef} />
        </div>
      </MessageListInfiniteScroll>
      {showBtnTopDown && (
        <Badge badgeContent={novasMensagens} color="primary" className={classes.badgeNovasMensagens}>
          <Fab variant="extended" onClick={reposicionarNovasMensagens} className={classes.btnChatTopDown}>
            <NavigationArrowDownward className={classes.icone} />
            {novasMensagens > 0
              ? intl.formatMessage({ defaultMessage: "Novas mensagens" })
              : intl.formatMessage({ defaultMessage: "Voltar ao final" })}
          </Fab>
        </Badge>
      )}

      {chat.envioMsgBloqueado ? (
        <ActionHSM handleSendHsm={handleNewHsmMessage} />
      ) : (
        <InputData onSendNewMessage={onSendMessage} onSendNewFile={onSendNewFile} />
      )}
    </Container>
  );
}

Chat.propTypes = {
  chat: PropTypes.object,
  messages: PropTypes.array,
  onSendMessage: PropTypes.func,
  onSendNewFile: PropTypes.func,
  handleNewHsmMessage: PropTypes.func,
};

export default withStyles(() => ({
  containerChatWpp: {
    height: "100%",
    overflowX: "hidden",
    overflowY: "auto",
    paddingLeft: 4,
    paddingRight: 4,
  },
  loadingChat: {
    maxHeight: 160,
  },
  badgeNovasMensagens: {
    zIndex: 9,
    position: "absolute",
    left: "28%",
    bottom: 50,
  },
  btnChatTopDown: {
    fontSize: 10,
    height: 28,
  },
  icone: {
    height: "18px !important",
    width: "18px !important",
  },
}))(Chat);
